import { useQuery } from "react-query";
import CoachStatisticsApiClient from "api/CoachStatisticsApiClient.js";

export function useGetCoachStatisticsBySchool(schoolId, payload, options) {
    return useQuery(
        ["trainingPlans", "school", Number(schoolId), payload],
        () => CoachStatisticsApiClient.getCoachStatisticsBySchool(schoolId, payload),
        options,
    );
}
